import React, { PureComponent } from 'react'
import { Image } from 'react-native'
import RNCheckBox from 'react-native-check-box'
import styled from 'styled-components/native'

const StyledImage = styled(Image)`
  width: 30px;
  height: 30px;
`

const checkedImage = (<StyledImage source={require('../../../assets/selected_radio.png')} />)
const unCheckedImage = (<StyledImage source={require('../../../assets/radio.png')} />)

export default class Radio extends PureComponent {
  render () {
    const {
      onClick,
      isChecked,
      text,
      disabled = false,
      style = {}
    } = this.props
    return (
      <RNCheckBox
        disabled={disabled}
        size={30}
        style={{ flex: 0, ...style }}
        onClick={onClick}
        isChecked={isChecked}
        rightText={text}
        checkedImage={checkedImage}
        unCheckedImage={unCheckedImage}
      />
    )
  }
}
